import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaRegCommentDots,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Footer from "../footer/footer";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (Object.values(formData).some((v) => v.trim() === "")) {
      alert("Please fill in all fields.");
      return;
    }

    console.log("Form Submitted:", formData);
    setSubmitted(true);

    setTimeout(() => setSubmitted(false), 3000);

    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <>
      {/* ==== HERO BANNER ==== */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <h1>Get in Touch With Lismount</h1>
        <p>We’re here to help. Reach out anytime.</p>
      </section>

      <section className="contact-section">
        <Container>
          {/* Section Heading */}
          <Row className="justify-content-center text-center mb-5">
            <Col md={10} lg={8}>
              <p className="contact-info-title">We'd Love to Hear From You</p>
              <h2 className="contact-main-title">
                Let’s Connect! Your Questions Matter to Us.
              </h2>
            </Col>
          </Row>

          {/* Info Boxes */}
          <Row className="text-center mb-5 contact-info-row">
            <Col md={4} sm={6} xs={12} className="mb-4">
              <div className="info-box">
                <div className="icon-circle">
                  <FaPhone />
                </div>
                <h5>Call Us</h5>
                <p>6238502812</p>

                {/* ⭐ Added Office Timing Here */}
                <p style={{ marginTop: "10px", fontSize: "0.95rem", color: "#475569" }}>
                  <strong>Office Timing:</strong><br />
                  Monday – Saturday<br />
                  09:00 AM – 07:00 PM
                </p>
              </div>
            </Col>


            <Col md={4} sm={6} xs={12} className="mb-4">
              <div className="info-box">
                <div className="icon-circle">
                  <FaMapMarkerAlt />
                </div>
                <h5>Visit Us</h5>
                <p>
                  <strong>LISMOUNT TEX INDIA LLP</strong>
                  <br />
                  339-A, Uthukuli - Chengapalli Road,
                  <br />
                  Tiruppur, Tamil Nadu 638812
                </p>
              </div>
            </Col>

            <Col md={4} sm={6} xs={12} className="mb-4">
              <div className="info-box">
                <div className="icon-circle">
                  <FaEnvelope />
                </div>
                <h5>Email Us</h5>
                <p>info@lismountindia.com</p>
              </div>
            </Col>
          </Row>

          {/* ==== FORM + IMAGE SIDE BY SIDE ==== */}
          <Row className="align-items-center form-image-wrapper">
            {/* Left side image */}
            <Col lg={5} className="contact-left-img">
              <div className="left-image-container">
                <img
                  src="/files/DSC06758.jpg"
                  alt="Factory Textile"
                  className="left-side-img"
                />
                <div className="img-overlay"></div>
                <h3 className="overlay-caption">Crafting Excellence Everyday</h3>
              </div>
            </Col>

            {/* Right side form */}
            <Col lg={7}>
              <Card className="contact-card">
                <Card.Body>
                  <h3 className="contact-title">
                    Send Us a <span>Message</span>
                  </h3>
                  <p className="contact-sub">
                    Have questions? Fill out the form below and our team will
                    reach out soon.
                  </p>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <div className="form-group-icon">
                          <FaUser className="input-icon" />
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="form-group-icon">
                          <FaEnvelope className="input-icon" />
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <div className="form-group-icon">
                          <FaPhone className="input-icon" />
                          <Form.Control
                            type="tel"
                            name="phone"
                            placeholder="Phone Number"
                            value={formData.phone}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="form-group-icon">
                          <FaRegCommentDots className="input-icon" />
                          <Form.Control
                            type="text"
                            name="subject"
                            placeholder="Subject"
                            value={formData.subject}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="form-group-icon textarea-wrapper">
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="message"
                        placeholder="Your Message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="text-center mt-4">
                      <Button type="submit" className="submit-btn">
                        Send Message
                      </Button>
                    </div>

                    {submitted && (
                      <p className="success-message mt-3">
                        ✅ Message Sent Successfully!
                      </p>
                    )}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default ContactForm;
